<template>
  <div>
    <Reassign :headers="headers" 
    :searchUrl="expenserequestlist.todoWorks" 
    :transferUrl="expenserequestlist.todoWorksPassTo" 
    itemValue="formId"
    />
  </div>
</template>

<script setup lang="ts">
import Reassign from './reassign/reassign.vue';
import { expenserequestlist } from './api/ExpenseRequestList/ExpenseRequestListApi';

definePage({
  meta: {
    action: 'manage',
    subject: 'EXPENSEREQUESTREASSIGN',
  },
})

const headers = [
  { title: '經費申請單號', key: 'applyNo', sortable: true },
  { title: '申請人', key: 'applyEmpNo', sortable: true },
  { title: '申請時間', key: 'applyTime', sortable: true },
];

</script>

<style>

</style>